// import { ViewChild } from "@angular/core";
import axios from "axios";
// import { jqxNotificationComponent } from "jqwidgets-ng/jqxnotification";
import { NgxSpinnerService } from "ngx-spinner";
import { Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpEvent, HttpProgressEvent } from '@angular/common/http';
import { BehaviorSubject, interval, Observable, Subject, Subscription } from 'rxjs';
import { error } from "console";
import { DatePipe } from "@angular/common";
import { BackendService } from "./backend.service";
import { openDB } from 'idb';
import { jqxNotificationComponent } from "jqwidgets-ng/jqxnotification";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class FileAccessService {
  constructor(private datePipe: DatePipe, private spinner: NgxSpinnerService, private backendService: BackendService, private router: Router) { }
  @ViewChild('msgNotification', { static: false }) msgNotification: jqxNotificationComponent;
   private seconds = 0;
  private timerSub!: Subscription;

  time = new BehaviorSubject<string>('00:00:00');
  recordingStatus = new BehaviorSubject<boolean>(false);
  pauseStatus = new BehaviorSubject<boolean>(false);
  //  private dbPromise = openDB('Recordings', 1, {
  //      upgrade(db) {
  //        db.createObjectStore('chunks', { keyPath: 'id', autoIncrement: true });
  //      },
  //    });
  private dbPromise = openDB('Recordings', 1, {
    upgrade(db) {
      db.createObjectStore('chunks', { keyPath: 'id', autoIncrement: true });
    },
  });
  private dbPromise2 = openDB('uploadedParts', 1, {
      upgrade(db) {
          db.createObjectStore('uploadedParts', { keyPath: 'id'});
      },
  });
   private readonly CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB
   recordingFileName : string = "" ;
    async downloadWithProgress(url: string, fileName: any, IsProgress) {
    return new Observable(observer => {
      axios({
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        url: url,
        method: 'GET',
        responseType: 'blob',
        // onDownloadProgress: this.calcProgress.bind(this, url, IsProgress)// important
        onDownloadProgress: (progressEvent) => {
          const percentLoaded = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          observer.next({type: 'progress', value: percentLoaded});
        },
        onUploadProgress: (progressEvent) => {
          const percentLoaded = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          observer.next({type: 'progress', value: percentLoaded});
        }
      })
      .then(response => {
        observer.next({type: 'response', value: response});
        const url = window.URL.createObjectURL(new Blob([response.data]));
        //this.progress=0
        //console.log(event.value.data.size);
        //this.filesize = event.value.data.size;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
    });
  }
  async uploadWithProgress(attachmenturl, filedetails) {
    return new Observable(observer => {
      axios.put(attachmenturl, filedetails, {
        onUploadProgress: (progressEvent) => {
          const percentLoaded = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          observer.next({type: 'progress', value: percentLoaded});
        }
      })
      .then(response => {
        observer.next({type: 'response', value: response});
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
    });
  }
  async excelFileDownload(ExportUrl,FileName) {
    await axios({
      headers: {
        'Access-Control-Allow-Origin': '*'
      },
      url: ExportUrl,
      method: 'GET',
      responseType: 'blob', // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        var date = new Date();
        var curdata = FileName + this.datePipe.transform(date, "yyyyMMddHHmmss") + ".csv";
        link.setAttribute('download', curdata);
        document.body.appendChild(link);
        link.click();
        this.spinner.hide();
      })
      .catch(err => console.log(err));
  }


  ReleaseNotesFileUpload(file: File, presignedUrl: string): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
  
    return axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,  // Ensure the correct content type is set
      }
    })
    .then(response => {
      console.log('File successfully uploaded:', response);
    })
    .catch(error => {
      console.error('Error during file upload:', error);
    });
  }
  ReleaseNotesFileDownload(presignedUrl: string): Promise<any> {
    return axios.get(presignedUrl, {
      responseType: 'blob', // Indicate that we expect a binary file
    })
    .then(response => {
      // Extract the original file name from the presigned URL and decode it
      const urlParts = presignedUrl.split('?')[0]; // Strip off the query parameters
      let fileName = urlParts.substring(urlParts.lastIndexOf('/') + 1); // Get the file name after the last '/'
      // Decode the file name (e.g., replace '%20' with ' ')
      fileName = decodeURIComponent(fileName); 
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      // Use the decoded file name for the download
      link.download = fileName; 
      link.click();
      // Clean up the URL object after the download
      window.URL.revokeObjectURL(downloadUrl);
      console.log('File downloaded successfully:', fileName);
      return response;
    })
    .catch(error => {
      console.error('Error downloading file:', error);
      throw error;
    });
  }
  async resumePendingUploads() {
    const db = await this.dbPromise;
    const allChunks = await db.getAll('chunks');
 
    
 
    if (allChunks.length === 0) {
      console.log('📭 No pending chunks found.');
      this.spinner.hide();
      return { success: false, response: null };
    }
    console.log(`🧩 Found ${allChunks.length} chunks pending upload.`);
 
    // Group by sessionId
    const sessions = new Map<string, any[]>();
    for (const chunk of allChunks) {
      const group = sessions.get(chunk.sessionId) || [];
      group.push(chunk);
      sessions.set(chunk.sessionId, group);
    }


 
    const response: any = await this.backendService.GetPreviousRecording().toPromise();
    var recorddetails = await this.backendService.getJSONResponse(response);
    console.log("recorddetails::", recorddetails);
    if (recorddetails.data.recording != null) {
      if (!recorddetails.data.recording.isUploaded) {
        const chunks = sessions.get(recorddetails.data.recording.sessionId);
        if (chunks) {
          console.log(`✅ Found session: ${recorddetails.data.recording.sessionId}`);
          var openRecordTab = await this.resumeUploadSession(chunks, recorddetails.data.recording.sessionId);
          return openRecordTab;
        } else {
          console.log(`❌ Session not found`);
          return { success: false, response: null };
        }
      }
    }
  }
  async resumeUploadSession(chunks: any[], sesID: string) {
    let partNumber = 0;
    const db = await this.dbPromise;
    var partETags: { PartNumber: number; ETag: string }[] = [];

    const db2 = await this.dbPromise2;

    const tx = db2.transaction('uploadedParts', 'readonly');
    const store = tx.objectStore('uploadedParts');
    const UploadedParts = await store.get(sesID);
    if(UploadedParts)
    {
      partETags = UploadedParts.partETags;
      partNumber = partETags.length;
      console.log(UploadedParts);
    }
    await tx.done;

    // Sort chunks in correct order (by index)
    chunks.sort((a, b) => {
      const ai = parseInt(a.id.split('-').pop() ?? '0', 10);
      const bi = parseInt(b.id.split('-').pop() ?? '0', 10);
      return ai - bi;
    });
 
    const { uploadId, fileKey, sessionId } = chunks[0];
    if (!uploadId || !fileKey) {
      console.warn(`⚠️ Missing upload session data for ${sessionId}`);
      return;
    }
 
    console.log(`🪣 Resuming multipart upload for session: ${sessionId}`);
 
    let buffer: any[] = [];
    let bufferSize = 0;
    //let partNumber = 1;
 
    for (const chunk of chunks) {
      buffer.push(chunk);
      bufferSize += chunk.data.byteLength;
 
      // Once we hit 5MB threshold → upload that group
      if (bufferSize >= this.CHUNK_SIZE) {
        const eTag = await this.uploadChunkGroup(db, buffer, uploadId, fileKey, partNumber +1, sessionId);
        if (eTag) partETags.push({ PartNumber: partNumber +1, ETag: eTag });
        partNumber++;
        buffer = [];
        bufferSize = 0;
      }
    }
 
    // Upload any leftover small buffer (final <5MB part)
    if (buffer.length > 0) {
      const eTag = await this.uploadChunkGroup(db, buffer, uploadId, fileKey, partNumber+1, sessionId, true);
      if (eTag) partETags.push({ PartNumber: partNumber +1, ETag: eTag });
    }
    // ✅ Finalize the multipart upload
    var openRecordTab = await this.completeMultipartUpload(uploadId, fileKey, partETags,sessionId);
    console.log(`✅ Multipart upload completed for ${fileKey}`);
    return openRecordTab;
  }
  async uploadChunkGroup(
  db: any,
  chunks: any[],
  uploadId: string,
  fileKey: string,
  partNumber: number,
  sessionId: string,
  isFinal = false
): Promise<string | null> {
  const blobsArray: Blob[] = [];
  let offset = 0;
  const chunkIds: string[] = [];
  for (const c of chunks) {
    blobsArray.push(c.data);
    chunkIds.push(c.id);
  }
  const blob = new Blob(blobsArray, { type: 'audio/webm' });
  const body = { uploadId, fileKey, partNumber };

  try {
    const presignedUrl = await this.backendService.GetUploadUrl(body).toPromise();
    const uploadUrl = JSON.parse(presignedUrl).data;

    const res = await fetch(uploadUrl, {
      method: "PUT",
      body: blob,
      headers: { "Content-Type": "audio/mpeg" },
    });

    if (res.ok) {
      const eTag = res.headers.get("ETag") ?? "";

      // Delete chunks
      const tx = db.transaction("chunks", "readwrite");
      const store = tx.objectStore("chunks");
      for (const c of chunks) await store.delete(c.id);
      await tx.done;

      return eTag; // ✅ ALWAYS return string
    } else {
      console.error(`❌ Upload failed for part #${partNumber}`);
      return null; // ❌ no object return
    }
  } catch (err) {
    console.error(`⚠️ Error uploading part #${partNumber}:`, err);
    return null; // ❌ must be null
  }
}

  async completeMultipartUpload(uploadId: string, Key: string, partETags: { PartNumber: number; ETag: string }[], sessionId: string) {
      try {
        const body = { uploadId, Key, partETags, sessionId };
        const res: any = await this.backendService.CompleteMultipart(body).toPromise();
         const parsedResponse = JSON.parse(res);
        this.spinner.hide();
        const db2 = await this.dbPromise2;

        const tx = db2.transaction('uploadedParts', 'readwrite');
        const store = tx.objectStore('uploadedParts');
        const result = await store.get(sessionId);
        if(result)
        {
          await store.delete(sessionId);   
          console.log("Session deleted from indexedDB:", sessionId);
        }
        await tx.done;

        return { success: true, response: parsedResponse };
      } catch (err) {
        console.error("❌ Error completing multipart upload:", err);
        this.sendNotification("Error completing multipart upload.", "error");
        return false;
      }
  }
  sendNotification(message, messageType) {
    this.msgNotification.elementRef.nativeElement.querySelector('.jqx-notification-content').innerHTML = message;
    this.msgNotification.template(messageType);
    this.msgNotification.open();
  }

   initTimerFromStorage() {
    const isRecording = localStorage.getItem('isStreamingRecording');
    const isPaused = localStorage.getItem('isRecordingPaused');
    const startTime = localStorage.getItem('recordingStartTime');

    if (isRecording === 'true' && startTime) {
      this.seconds = Math.floor((Date.now() - Number(startTime)) / 1000);
      this.time.next(this.formatTime(this.seconds));

      this.recordingStatus.next(true);

      if (isPaused === 'true') {
        this.pauseStatus.next(true);
      } else {
        this.startTimer();
      }
    }
  }

  start() {
    const startTime = Date.now();

    localStorage.setItem('isStreamingRecording', 'true');
    localStorage.setItem('isRecordingPaused', 'false');
    localStorage.setItem('recordingStartTime', startTime.toString());

    this.seconds = 0;
    this.time.next('00:00:00');

    this.recordingStatus.next(true);
    this.pauseStatus.next(false);

    this.startTimer();
  }

  pause() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
      this.timerSub = undefined as any;
    }

    localStorage.setItem('isRecordingPaused', 'true');
    localStorage.setItem('pausedSeconds', this.seconds.toString());

    this.pauseStatus.next(true);
  }

  resume() {
    const pausedSeconds = Number(localStorage.getItem('pausedSeconds') || 0);
    const newStartTime = Date.now() - pausedSeconds * 1000;

    localStorage.setItem('recordingStartTime', newStartTime.toString());
    localStorage.setItem('isRecordingPaused', 'false');

    this.pauseStatus.next(false);
    this.startTimer();
  }

  stop() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
      this.timerSub = undefined as any;
    }

    this.seconds = 0;
    this.time.next('00:00:00');

    localStorage.removeItem('isStreamingRecording');
    localStorage.removeItem('isRecordingPaused');
    localStorage.removeItem('recordingStartTime');
    localStorage.removeItem('pausedSeconds');

    this.recordingStatus.next(false);
    this.pauseStatus.next(false);
  }

  private startTimer() {
    if (this.timerSub) return;

    this.timerSub = interval(1000).subscribe(() => {
      this.seconds++;
      this.time.next(this.formatTime(this.seconds));
    });
  }

  private formatTime(totalSeconds: number): string {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}
